"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = parse;
/* eslint-disable */

/**
 * Utility uses a modified version of Snarkdown package.
 *
 * snarkdown
 * Transform Markdown into HTML
 * version: 2.0.0
 * Jason Miller <jason@developit.ca>
 * https://github.com/developit/snarkdown
 */

var TAGS = {
  '': ['<em class="markdown__color-brand-mid">', '</em>'],
  _: ['<strong class="markdown__strong">', '</strong>'],
  '*': ['<strong class="markdown__strong">', '</strong>'],
  '~': ['<s class="markdown__strike">', '</s>'],
  '\n': ['<br class="markdown__break" />'],
  ' ': ['<br class="markdown__break" />'],
  '-': ['<hr class="markdown__rule" />']
};

/** Outdent a string based on the first indented line's leading whitespace
 *	@private
 */
function outdent(str) {
  return str.replace(RegExp("^".concat((str.match(/^(\t| )+/) || '')[0]), 'gm'), '');
}

/** Encode special attribute characters to HTML entities in a String.
 *	@private
 */
function encodeAttr(str) {
  return "".concat(str).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

/** Parse Markdown into an HTML String. */
function parse(md, prevLinks) {
  var tokenizer = /((?:^|\n+)(?:\n---+|\* \*(?: \*)+)\n)|(?:^``` *(\w*)\n([\s\S]*?)\n```$)|((?:(?:^|\n+)(?:\t|  {2,}).+)+\n*)|((?:(?:^|\n)([>*+-]|\d+\.)\s+.*)+)|(?:!\[([^\]]*?)\]\(([^)]+?)\))|(\[)|(\](?:\(([^)]+?)\))?)|(?:(?:^|\n+)([^\s].*)\n(-{3,}|={3,})(?:\n+|$))|(?:(?:^|\n+)(#{1,6})\s*(.+)(?:\n+|$))|(?:`([^`].*?)`)|( {2}\n\n*|\n{2,}|__|\*\*|[_*]|~~)|(<p>)/gm;
  var context = [];
  var out = '';
  var links = prevLinks || {};
  var last = 0;
  var chunk;
  var prev;
  var token;
  var inner;
  var t;
  function tag(token) {
    var desc = TAGS[token[1] || ''];
    var end = context[context.length - 1] == token;
    if (!desc) return token;
    if (!desc[1]) return desc[0];
    if (end) context.pop();else context.push(token);
    return desc[end | 0];
  }
  function flush() {
    var str = '';
    while (context.length) str += tag(context[context.length - 1]);
    return str;
  }
  md = md.replace(/^\[(.+?)\]:\s*(.+)$/gm, function (s, name, url) {
    links[name.toLowerCase()] = url;
    return '';
  }).replace(/^\n+|\n+$/g, '');
  while (token = tokenizer.exec(md)) {
    prev = md.substring(last, token.index);
    last = tokenizer.lastIndex;
    chunk = token[0];
    if (prev.match(/[^\\](\\\\)*\\$/)) {
      // escaped
    }
    // Code/Indent blocks:
    else if (t = token[3] || token[4]) {
      chunk = "<pre class=\"markdown__code ".concat(token[4] ? 'poetry' : token[2].toLowerCase(), "\"><code").concat(token[2] ? " class=\"markdown__code--".concat(token[2].toLowerCase(), "\"") : '', ">").concat(outdent(encodeAttr(t).replace(/^\n+|\n+$/g, '')), "</code></pre>");
    }
    // > Quotes, -* lists:
    else if (t = token[6]) {
      var className = '';
      var listItemClassName = '';
      if (t.match(/\./)) {
        token[5] = token[5].replace(/^\d+/gm, '');
      }
      inner = parse(outdent(token[5].replace(/^\s*[>*+.-]/gm, '')));
      if (t == '>') t = 'blockquote';else {
        // Ordered list and unordered list
        // Adds class names to ol, ul and li tags
        className = t.match(/\./) ? 'markdown__ordered-list' : 'markdown__unordered-list';
        listItemClassName = t.match(/\./) ? 'markdown__ordered-list-item' : 'markdown__unordered-list-item';
        t = t.match(/\./) ? 'ol' : 'ul';
        inner = inner.replace(/^(.*)(\n|$)/gm, "<li class=\"".concat(listItemClassName, "\">$1</li>"));
      }
      chunk = "<".concat(t, " class=\"").concat(className, "\">").concat(inner, "</").concat(t, ">");
    }
    // Images:
    else if (token[8]) {
      chunk = "<img src=\"".concat(encodeAttr(token[8]), "\" alt=\"").concat(encodeAttr(token[7]), "\">");
    }
    // Links:
    else if (token[10]) {
      out = out.replace('<a>', "<a class=\"markdown__link\" href=\"".concat(encodeAttr(token[11] || links[prev.toLowerCase()]), "\">"));
      chunk = "".concat(flush(), "</a>");
    } else if (token[9]) {
      chunk = '<a>';
    }
    // Headings:
    else if (token[12] || token[14]) {
      t = "h".concat(token[14] ? token[14].length : token[13] > '=' ? 1 : 2);
      chunk = "<".concat(t, " class=\"markdown__").concat(t, "\">").concat(parse(token[12] || token[15], links), "</").concat(t, ">");
    }
    // `code`:
    else if (token[16]) {
      chunk = "<code class=\"markdown__code\">".concat(encodeAttr(token[16]), "</code>");
    }
    // Inline formatting: *em*, **strong** & friends
    else if (token[17] || token[1]) {
      chunk = tag(token[17] || '--');
    }
    // Paragraphs
    else if (token[18]) {
      // Add class name to paragraph
      chunk = "<p class=\"markdown__typography-paragraph\">";
    }
    out += prev;
    out += chunk;
  }
  return (out + md.substring(last) + flush()).replace(/^\n+|\n+$/g, '');
}